import 'jquery';
import trackButtonClick from '../../snowplow/snowplow_track_button_click';

$(() => {
  $(document).on('click', '.wishlist-product-remove-js', function (e) {
    e.preventDefault();
    $.ajax({
      url: $(this).attr('href'),
      dataType: 'json',
      success() {
        window.location.reload();
      },
    });
  });

  $(document).on('click', '.wishlist-geturl-js', function (e) {
    e.preventDefault();
    trackButtonClick({ label: 'generate_wishlist_link' });
    $.ajax({
      url: $(this).attr('href'),
      dataType: 'json',
      success(json) {
        $('#urlbox').val(json.short_url);
        $('.cart_urlbox').removeClass('hide');
        $('.cart_buttons').addClass('hide');
      },
    });
  });

  // eslint-disable-next-line prefer-arrow-callback
  $('.url-copy-js').on('click', function (e) {
    e.preventDefault();
    const url = $('#urlbox').val();
    navigator.clipboard.writeText(url);
  });
});
